<template>
	<div class="Baseinput">
		<label v-if="label">
			{{ label }}
		</label>
		<input
			:value="value"
			v-bind="$attrs"
			:class="customClass"
			@input="updateValue"
			v-on="listeners"
		/>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		label: {
			type: String,
			default: ""
		},
		value: {
			type: [String, Number],
			default: ""
		},
		customClass: {
			type: String,
			default: ""
		}
	},
	computed: {
		listeners() {
			return {
				...this.$listeners,
				input: this.updateValue
			};
		}
	},
	methods: {
		updateValue(event) {
			this.$emit("input", event.target.value);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variable.scss";

.Baseinput input::placeholder {
	font-size: 12px;
	color: $input-placeholder-color;
}
.Baseinput input {
	// outline-style: auto;
	width: 100%;
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	height: 40px;
	outline: 0;
	font-size: 12px;
	padding: 0 15px;
}
.Baseinput input:focus {
	border: 1px solid #8fa7e1;
	outline: none;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input:disabled {
	background-color: #f5f7fa;
}
.disabled-bg-white input:disabled {
	background-color: #fff;
}
</style>
